// extracted by mini-css-extract-plugin
export default {"container":"GlanceStats_container__hHNWG"};